module.exports = __webpack_public_path__ + "img/sky.d83382b.svg";